import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberInfoData: null,
};

const memberInfoSlice = createSlice({
  name: "memberInfo",
  initialState,
  reducers: {
    setMemberInfoData: (state, action) => {
      state.memberInfoData = action.payload;
    },
    clearMemberInfoData: (state) => {
      state.memberInfoData = null;
    },
  },
});

export const { setMemberInfoData,clearMemberInfoData } = memberInfoSlice.actions;
export default memberInfoSlice.reducer;
